import { styled } from '@mui/material'

export const HeaderBox = styled('header')(({ theme }) => ({
  backgroundColor: '#02040DCC',
  width: '100%',
  zIndex: 10000,
  position: 'fixed',
  top: 0
}))
